export const messageRecall = "ExhX3";
export default {messageRecall};